// libs
import { AnyAction, combineReducers, Reducer } from 'redux'

// interfaces / constants
import { MailboxReducer } from '@lopo-tech/frontends-shared'
import { IRootState } from './interface'

// helpers
import appState from 'src/reducers/app-state/app-state'
import filters from 'src/reducers/filters/filters'
import user from 'src/reducers/user/user'

export const PROFILE_SWITCH_RESET = 'PROFILE_SWITCH_RESET'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const combinedReducer: Reducer<IRootState> = combineReducers({
  appState,
  filters,
  mailbox: MailboxReducer,
  user
}) as any

const getRootReducer = (): Reducer<IRootState> => (state: IRootState | undefined, action: AnyAction) => {
  if (action.type === PROFILE_SWITCH_RESET && state) {
    // Reset profile-specific state by passing undefined (triggers initial state)
    // Preserve user state since UserDataProvider will update it via USER_ME_REQUEST_SUCCESS
    return combinedReducer(
      { user: state.user } as unknown as IRootState,
      action
    )
  }
  return combinedReducer(state, action)
}

export default getRootReducer
